import { origin } from '@porotutu/react/api'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({ baseURL: `${origin()}/api/auth/adm` })

export const { signIn, signOut } = authClient

export const leave = () => signOut()
